import axiosInstance from './AxiosInstance';

export function getRoomCategories() {
    return axiosInstance.get(`/roomcategories`);
}

export function createRoomCategory(categoryData) {
    return axiosInstance.post(`/roomcategory`, categoryData);
}

export function updateRoomCategory(category, categoryId) {
    return axiosInstance.put(`/roomcategory/${categoryId}`, category);
}

export function deleteRoomCategory(categoryId) {
    return axiosInstance.delete(`/roomcategory/${categoryId}`);
}
